import React from 'react';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';



export default function MenuList({endIcon, startIcon, items, onClick, value }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ maxWidth: '100%', minWidth: 0 }}>      
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        size="small"
        endIcon={endIcon} 
        startIcon={startIcon}
        onClick={handleClick}
        sx={{
          maxWidth: '100%',
          minWidth: 0,
          justifyContent: 'space-between',
          textTransform: 'none',
          '& .MuiButton-endIcon': { flexShrink: 0 },
          '& .MuiButton-startIcon': { flexShrink: 0 },
        }}
      >
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
            minWidth: 0,
          }}
        >
          {value}
        </span>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {items && items.map((item, n) => {
            return (
                <MenuItem onClick={() => { handleClose(); item.onClick && item.onClick(); }} key={n}>{item.value}</MenuItem>
            )
        })}        
      </Menu>
    </div>
  );
}
